module.exports = __webpack_public_path__ + "img/4.79b59e85.jpg";